module.exports = __webpack_public_path__ + "img/add_car_tc.2d226248.png";